import {ACTION_CODE} from './_actionCode';
import {ServicesService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';

const FUNCTION_CODE = 'CREATE_SERVICE';

export async function createService(token = '', payload: Record<string, unknown>) {
    try {
        LoggerService.logInfo('Action - createService - Start');

        const result = await ServicesService.createService(token, payload);

        LoggerService.logInfo('Action - createService - End - Success');

        return ResultModel.newSuccessResult(result);
    }
    catch (error) {
        LoggerService.logInfo('Action - createService - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la création du service',
            error: error
        });
        
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
